exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pfe-splitpanes.splitpanes.default-theme{height:100%}.pfe-splitpanes.splitpanes.default-theme .splitpanes__pane{overflow:hidden}", ""]);

// exports
